/**
* Replace the normal setTimeout function with one
* that treats 0 and 1 as the same
* This is an attempt to preserve prior Chrome behavior where setTimeout with a delay of 0 and 1 were identical
* We want to normalize to 1 (which is what the browser used to do) because otherwise, it can create
* conditions where something like Knockout uses a setTimeout(0), and _.defer uses a setTimeout(1),
* and now you have a behavior difference after the browser update
* See this bug: https://dev.azure.com/cartegraph/Cartegraph/_workitems/edit/136903
* And discussion here: https://groups.google.com/a/chromium.org/g/blink-dev/c/HKPTp7C1LwY
*/
(function () {
  var originalSetTimeout = window.setTimeout;

  window.setTimeout = function(func, delay, ...args) {
      if (delay === 0) delay = 1;

      return originalSetTimeout(func, delay, ...args);
  };
})();